<header class="mobile-app-bar shadow-4" [class.mobile-app-bar--collapsed]="collapsed">
  <button
    type="button"
    pButton
    pRipple
    class="mobile-app-bar__leading p-button-text p-button-plain"
    [attr.aria-label]="(isDetailView ? 'common.button.back' : 'shared.mobile_navigation.open_drawer') | translate"
    (click)="onLeadingAction()"
  >
    <i *ngIf="isDetailView" class="pi pi-arrow-left"></i>
    <span *ngIf="!isDetailView" class="mobile-app-bar__brand">
      <img src="../../../assets/layout/images/wtg-logo-transparent-white-sm.webp" alt="WTG">
      <span>WTG</span>
    </span>
  </button>

  <button
    type="button"
    class="mobile-app-bar__hub"
    [attr.aria-label]="'shared.mobile_navigation.open_hub' | translate"
    [attr.aria-expanded]="hubOpen"
    (click)="openHub()"
  >
    <span class="mobile-app-bar__hub-label">{{ hubTitle }}</span>
    <i class="pi pi-angle-down"></i>
  </button>

  <div class="mobile-app-bar__actions">
    <button
      *ngIf="breadcrumb.filtersVisible"
      type="button"
      pButton
      pRipple
      icon="pi pi-sliders-h"
      class="p-button-text p-button-plain mobile-app-bar__action"
      [attr.aria-label]="'common.filters' | translate"
      (click)="openFilters()"
    ></button>
    <button
      *ngIf="canChangeView"
      type="button"
      pButton
      pRipple
      class="p-button-text p-button-plain mobile-app-bar__action"
      [icon]="viewChangeIcon"
      [attr.aria-label]="(actionsService.viewType === ViewTypeEnum.LIST ? 'shared.mobile_navigation.view_grid' : 'shared.mobile_navigation.view_list') | translate"
      (click)="toggleView()"
    ></button>
    <button
      type="button"
      pButton
      pRipple
      class="p-button-text p-button-plain mobile-app-bar__action mobile-app-bar__notifications"
      [attr.aria-label]="'shared.mobile_navigation.notifications' | translate"
      (click)="openNotifications()"
    >
      <i class="pi pi-bell"></i>
      <span *ngIf="unreadCount" class="mobile-app-bar__badge">{{ unreadCount > 99 ? '99+' : unreadCount }}</span>
    </button>
  </div>
</header>

<section
  *ngIf="searchOpen"
  class="mobile-search-overlay"
  role="dialog"
  aria-modal="true"
  [attr.aria-label]="'common.search' | translate"
>
  <div class="mobile-search-overlay__header">
    <button
      type="button"
      pButton
      pRipple
      icon="pi pi-arrow-left"
      class="p-button-text p-button-plain mobile-search-overlay__back"
      [attr.aria-label]="'common.close' | translate"
      (click)="closeSearch()"
    ></button>
    <div class="mobile-search-overlay__input p-inputgroup">
      <span class="p-inputgroup-addon"><i class="pi pi-search"></i></span>
      <input
        #mobileSearchInput
        type="search"
        pInputText
        [(ngModel)]="searchQuery"
        [placeholder]="'shared.top_bar.placeholder.search' | translate"
        (ngModelChange)="onSearchQueryChange($event)"
        (keyup.enter)="submitSearch()"
      >
      <button
        *ngIf="searchQuery"
        type="button"
        pButton
        pRipple
        icon="pi pi-times"
        class="p-button-text p-button-plain mobile-search-overlay__clear"
        [attr.aria-label]="'common.close' | translate"
        (click)="searchQuery = ''; onSearchQueryChange('')"
      ></button>
    </div>
  </div>
  <app-search-list
    *ngIf="user"
    class="mobile-search-overlay__results"
    [phrase]="searchQuery"
    [user]="user"
  ></app-search-list>
</section>

<app-bottom-sheet
  #hubBottomSheet
  [backdrop]="true"
  [middleBreakHeight]="hubMiddleBreakHeight"
  (dismissed)="onHubDismissed()"
>
  <section class="mobile-navigation-hub" [attr.aria-hidden]="!hubOpen">
  <div class="mobile-navigation-hub__context" *ngIf="breadcrumbItems.length">
    <span *ngFor="let item of breadcrumbItems; let last = last">
      {{ item.label }}<i *ngIf="!last" class="pi pi-angle-right"></i>
    </span>
  </div>
  <div class="mobile-navigation-hub__list">
    <button
      *ngFor="let resource of hubResources"
      type="button"
      class="mobile-navigation-hub__resource"
      [class.mobile-navigation-hub__resource--active]="isCurrentHubResource(resource.id)"
      (click)="navigateTo(resource.id)"
    >
      <span class="mobile-navigation-hub__resource-icon"><i [class]="resource.icon"></i></span>
      <span>{{ resource.labelKey | translate }}</span>
      <i *ngIf="isCurrentHubResource(resource.id)" class="pi pi-check mobile-navigation-hub__resource-check"></i>
    </button>
  </div>
  </section>
</app-bottom-sheet>
